import { ExportDataButton } from "components/ExportDataButton";
import { OmnisearchDataGrid } from "components/OmnisearchDataGrid";
import { gql } from "generated-graphql";
import {
  DestinationViewType,
  WasteStreamDestinationsQuery,
  WasteStreamDestinationsQueryVariables,
} from "generated-graphql/graphql";
import { useTenant } from "hooks/useTenant";

import { useWasteFacilityState } from "../../WasteFacilityContext";
import { useDestinationsGrid } from "./useDestinationsGrid";

const WASTE_STREAM_DESTINATIONS = gql(`
  query WasteStreamDestinationsV1(
    $wasteStreamId: ID!
    $view: FacilityWasteView
    $viewType: DestinationViewType!
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
    $startDate: Date
    $endDate: Date
  ) {
    wasteStreamDestinations(
      wasteStreamId: $wasteStreamId
      view: $view
      viewType: $viewType
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
      startDate: $startDate
      endDate: $endDate
    ) {
      items {
        destinationFacilityId
        destinationFacilityName
        managementMethodCode
        vendorAmount
        eManifestAmount
      }
      count
    }
  }
`);

interface DestinationsViewProps {
  wasteStreamId: string;
  viewType: DestinationViewType;
}

export const DestinationsView = ({ wasteStreamId, viewType }: DestinationsViewProps) => {
  const { tenantId } = useTenant();
  const { columns, getRowId } = useDestinationsGrid(viewType);
  const {
    wasteFacilityState: { deferredFilters },
  } = useWasteFacilityState();

  return (
    <OmnisearchDataGrid<WasteStreamDestinationsQuery, WasteStreamDestinationsQueryVariables, any>
      withPadding={false}
      persistenceKey="waste-stream-destinations-v1"
      isURLDriven={false}
      columns={columns}
      dataQuery={WASTE_STREAM_DESTINATIONS}
      fetchPolicy="cache-first"
      getRowId={getRowId}
      getItems={(data) => data.wasteStreamDestinations?.items ?? []}
      getCount={(data) => data.wasteStreamDestinations?.count ?? 0}
      dataQueryVariables={{
        wasteStreamId,
        viewType,
        view: deferredFilters.view,
        startDate: deferredFilters.startDate,
        endDate: deferredFilters.endDate,
      }}
      commandButtons={({ search }) => [
        <ExportDataButton
          key="export"
          exportType="wasteStreamDestinations"
          fileName="waste-stream-destinations"
          tenantId={tenantId ?? ""}
          filter={{
            viewType,
            wasteStreamId,
            search,
          }}
          iconOnly
        />,
      ]}
      noDataMessage="No destinations found for this waste stream."
      pageSizeOptions={[5, 10, 25]}
      hideFooter={false}
    />
  );
};
